export var lang_preferance = 'eng';

export const changeLangPref = (lang) => {
    lang_preferance = lang || 'eng';
}